/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateTeamUserDto } from './createTeamUserDto';
import { CompanyRefDto } from './companyRefDto';
import { AssetRefDto } from './assetRefDto';


export interface UpdateTeamDto { 
    name?: string;
    status?: UpdateTeamDto.StatusEnum;
    agency?: CompanyRefDto;
    users?: Array<CreateTeamUserDto>;
    assets?: Array<AssetRefDto>;
}
export namespace UpdateTeamDto {
    export type StatusEnum = 'active' | 'inactive';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


